"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.find-index.js");
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _typeValidation = _interopRequireDefault(require("./typeValidation"));
var _rating = require("@citrus/rating");
var _PctyQuestion = require("./PctyQuestion.Common");
var _isNotNullOrEmpty = _interopRequireDefault(require("@pcty/utils-commonjs/value/isNotNullOrEmpty"));
require("./index.css");
var PctyQuestionRatingScale = function PctyQuestionRatingScale(_ref) {
  var id = _ref.id,
    number = _ref.number,
    disabled = _ref.disabled,
    readOnly = _ref.readOnly,
    required = _ref.required,
    scenario = _ref.scenario,
    question = _ref.question,
    response = _ref.response,
    hint = _ref.hint,
    onResponse = _ref.onResponse,
    options = _ref.options,
    minimumRateLabel = _ref.minimumRateLabel,
    maximumRateLabel = _ref.maximumRateLabel,
    allowComments = _ref.allowComments,
    commentsPlaceholder = _ref.commentsPlaceholder,
    comment = _ref.comment,
    onComment = _ref.onComment;
  var onItemClick = function onItemClick(item) {
    if (readOnly) return;
    if (onResponse) onResponse(id, item ? item.id || item.value : 0);
  };
  var items = options.map(function (itm, index) {
    return {
      id: itm.id,
      value: index + 1,
      label: itm.value
    };
  });
  var getSelectedItemIndex = function getSelectedItemIndex() {
    var itemIndex = -1;
    if ((0, _isNotNullOrEmpty.default)(response) && (0, _isNotNullOrEmpty.default)(options)) {
      // find the response's itemIndex anyway we can
      var responseValue = Array.isArray(response) ? response[0].optionId : response;
      itemIndex = options.findIndex(function (x) {
        return x.id === responseValue;
      });

      // if we didn't find it but it has a valid response, somehow the raw value got stored, so unpack it
      if (itemIndex === -1 && parseInt(responseValue) !== NaN && parseInt(responseValue) <= options.length) {
        itemIndex = parseInt(responseValue) - 1;
      }
    }
    return itemIndex;
  };
  var itemResponse = getSelectedItemIndex();
  var noResponseDisableComments = itemResponse < 0;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _PctyQuestion.renderHint)(id, hint), (0, _PctyQuestion.renderScenario)(id, scenario), (0, _PctyQuestion.renderQuestion)(id, number, question, required, readOnly), /*#__PURE__*/_react.default.createElement("span", {
    className: "pcty-level-1-footnote"
  }, minimumRateLabel), /*#__PURE__*/_react.default.createElement("span", {
    className: "pcty-level-1-footnote pcty-float-right pcty-hidden-mobile"
  }, maximumRateLabel), /*#__PURE__*/_react.default.createElement("div", {
    className: "pcty-rating-scale-buttons"
  }, /*#__PURE__*/_react.default.createElement(_rating.ButtonRating, {
    id: id,
    items: items,
    onItemClick: onItemClick,
    disabled: disabled || readOnly,
    automationId: "question-".concat(number, "-rating-scale-button-rating"),
    value: itemResponse + 1
  })), /*#__PURE__*/_react.default.createElement("span", {
    className: "pcty-level-1-footnote pcty-hidden-above-mobile"
  }, maximumRateLabel), (0, _PctyQuestion.renderQuestionComment)(id, readOnly, allowComments, commentsPlaceholder, comment, onComment, noResponseDisableComments));
};
PctyQuestionRatingScale.propTypes = (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({
  /** The array of option objects. */
  options: _propTypes.default.array.isRequired,
  /** A hint that you want to give the person answering the question. */
  hint: _propTypes.default.string,
  /** The text to display near the minimum rate value. */
  minimumRateLabel: _propTypes.default.string,
  /** The text to display near the maximum rate value. */
  maximumRateLabel: _propTypes.default.string,
  /** The id for the component. */
  id: _propTypes.default.string.isRequired,
  /** The question number. */
  number: _propTypes.default.number.isRequired,
  /** Whether or not the question will be disabled. */
  disabled: _propTypes.default.bool,
  /** Whether or not the question will be readOnly. */
  readOnly: _propTypes.default.bool,
  /** Whether or not the question will be displayed as required. */
  required: _propTypes.default.bool,
  /** Callback function that receives response information each time someone interacts with the question. */
  onResponse: _propTypes.default.func.isRequired,
  /** The question text. */
  question: _propTypes.default.string.isRequired,
  /** An array of response objects that are output from the component. */
  response: _propTypes.default.any
}, "minimumRateLabel", _propTypes.default.string), "maximumRateLabel", _propTypes.default.string), "scenario", _propTypes.default.string), "allowComments", _propTypes.default.bool), "commentsPlaceholder", _propTypes.default.string), "comment", _propTypes.default.string), "onComment", _propTypes.default.func.isRequired), "__TYPE", function __TYPE(props, propName, componentName) {
  return (0, _typeValidation.default)(props, propName, componentName, 'PctyQuestionRatingScale');
});
PctyQuestionRatingScale.defaultProps = {
  scenario: null,
  disabled: false,
  readOnly: false,
  __TYPE: 'PctyQuestionRatingScale',
  allowComments: false
};
var _default = exports.default = PctyQuestionRatingScale;